import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=0e4aa0b6&scoped=true"
import script from "./VTable.vue?vue&type=script&lang=ts"
export * from "./VTable.vue?vue&type=script&lang=ts"
import style0 from "./VTable.vue?vue&type=style&index=0&id=0e4aa0b6&prod&lang=scss&scoped=true"
import style1 from "./VTable.vue?vue&type=style&index=1&id=0e4aa0b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4aa0b6",
  null
  
)

export default component.exports